$(document).ready(function() {
  $('.smooth-scroll').on('click', function(evt) {
    evt.preventDefault();
    
    // Get the target element's offset top position
    var targetElement = $($(this).attr('href'));
    var targetOffsetTop = targetElement.offset().top;
    
    // Animate scrolling to the target element
    $('html, body').animate(
      { scrollTop: targetOffsetTop },
      500
    );
  });
});